import type { FC } from 'react';
import { Fragment } from 'react';
import { Inline, LineBreak } from '@george-labs.com/design-system';

import type { CommonItemProps } from './types';
import { ProductsListItemWrapper } from '../ProductsListItemWrapper';

type Props = CommonItemProps & {
    contentArray: string[];
};

export const ProductsListMultipleTextItem: FC<Props> = ({
    'data-cy': dataCy,
    className,
    label,
    labelClassName,
    labelColumnWidth,
    contentArray,
}) => (
    <ProductsListItemWrapper
        data-cy={dataCy}
        className={className}
        label={label}
        labelClassName={labelClassName}
        labelColumnWidth={labelColumnWidth}
    >
        {contentArray.filter(Boolean).map((content, index) => (
            <Fragment key={content}>
                <Inline data-cy={`${dataCy}-${index}`}>{content}</Inline>
                <LineBreak />
            </Fragment>
        ))}
    </ProductsListItemWrapper>
);
